var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 17.5L5 17.5C3.61917 17.5 2.5 16.3808 2.5 15L2.5 5C2.5 3.61917 3.61917 2.5 5 2.5L15 2.5C16.3808 2.5 17.5 3.61917 17.5 5L17.5 15C17.5 16.3808 16.3808 17.5 15 17.5Z",
    fill: "#7294FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 11.1842L11.6665 2.85087C11.6665 1.93004 10.9207 1.1842 9.99984 1.1842C9.079 1.1842 8.33317 1.93004 8.33317 2.85087L8.33317 11.1842L11.6665 11.1842Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55762 9.99995C5.91512 9.99995 5.59179 10.7749 6.04429 11.2316L9.25762 14.4758C9.66679 14.8883 10.3335 14.8883 10.7426 14.4758L13.956 11.2316C14.4085 10.7749 14.0851 9.99995 13.4426 9.99995L6.55762 9.99995Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIc);
export default __webpack_public_path__ + "static/media/download_ic.de3f6031daf8f2788efcc18212475932.svg";
export { ForwardRef as ReactComponent };